import { observer } from "mobx-react-lite";
import React from "react";

import {
  FontIcon,
  TextBadge,
  TextBadgeColor,
  TextBadgeSize,
  TooltipHost
} from "@bps/fluent-ui";
import { getDiagnosisText } from "@stores/acc/utils/acc.utils.ts";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { withFetch } from "@ui-components/data-fetcher/DataFetcher.tsx";

export interface ClaimAdditionalDiagnosesBadgeProps {
  episodeOfCare: EpisodeOfCare;
}

const ClaimAdditionalDiagnosesBadgeBase: React.FC<ClaimAdditionalDiagnosesBadgeProps> =
  observer(props => {
    const { acc } = useStores();

    const { episodeOfCare } = props;

    if ((episodeOfCare.claim?.currentDiagnoses.length ?? 0) <= 1) return null;

    return (
      <TextBadge
        badgeColor={TextBadgeColor.lightGrey}
        badgeSize={TextBadgeSize.medium}
        horizontal
        horizontalAlign="center"
        tokens={{ childrenGap: 4 }}
      >
        <span>Additional diagnoses</span>
        <TooltipHost
          content={episodeOfCare.claim?.currentDiagnoses
            .slice(1)
            .map(diagnosis => getDiagnosisText(diagnosis, acc))
            .join(", ")}
        >
          <FontIcon iconName="Info" />
        </TooltipHost>
      </TextBadge>
    );
  });

export const ClaimAdditionalDiagnosesBadge = withFetch(
  ({ acc }) => [acc.ref.diagnosisSides.load()],
  ClaimAdditionalDiagnosesBadgeBase
);
